import { Condition } from './Condition';
import { Segment } from './SegmentList';
import { Switch } from './Switch';

import {
  DuplicateInputRequest,
  SaveSegmentRequest,
  SegmentTypeEnum,
} from 'workflow-definition/openapi';

export interface SaveSegmentMutation {
  workflowId: number;
  segmentRefId?: number;
  saveSegmentRequest: SaveSegmentRequest;
  isNameChange?: boolean;
}

export interface SegmentSelected extends Segment {
  id?: number;
  order?: number;
  selected?: boolean;
  type?: SegmentTypeEnum | undefined;
  segmentSwitches: Switch[];
  conditionals: Condition[];
  blockers: Condition[];

  segmentId: number | undefined;
  name?: string | null | undefined;
  title?: string | null | undefined;
  items: string[] | undefined;
}

export interface DeleteSegmentMutation {
  workflowId: number;
  segmentRefId: number;
}

export interface ReorderSegmentMutation {
  workflowId: number;
  segmentRefId: number;
  order: number;
}

export interface TemplateSaveSegmentMutation {
  segmentId: number;
  saveSegmentRequest: SaveSegmentRequest;
}

export interface DuplicateSegmentMutation {
  workflowId: number;
  segmentId: number;
  duplicateSegmentInputRequest: DuplicateInputRequest;
}

export enum DuplicateSegmentOptions {
  DUPLICATE_SEGMENT = 'duplicateSegment',
  // One template option only: the server scopes the template from the session, so a global admin's
  // save already produces a global template.
  TEMPLATE_SEGMENT = 'saveAsTemplate',
  EXPORT_SEGMENT = 'exportSegment',
  DELETE_SEGMENT = 'deleteSegment',
}
